import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import s from './tweet-card.module.css';
import infoStyles from './tweet-info.module.css';
import { formatRemainingTime } from '../date-utils.js';
import { formatVoteCount } from '../utils.js';
export const TweetCard = ({ card })=>{
    // Poll card, e.g. https://x.com/elonmusk/status/1604617643973124097
    return card.name.startsWith('poll') ? /*#__PURE__*/ _jsx(TweetPoll, {
        poll: card.binding_values
    }) : undefined;
};
const TweetPoll = ({ poll })=>{
    const totalChoiceCount = Object.keys(poll).filter((key)=>key.startsWith('choice') && key.endsWith('_label')).length;
    const totalVoteCount = Object.keys(poll).filter((key)=>key.startsWith('choice') && key.endsWith('_count')).reduce((acc, key)=>{
        return acc + parseInt(poll[key].string_value);
    }, 0);
    const choicePercentages = Array.from({
        length: totalChoiceCount
    }, (_, i)=>{
        const choiceCount = poll[`choice${i + 1}_count`].string_value;
        return (parseInt(choiceCount) / totalVoteCount * 100).toFixed(1);
    });
    const choices = Array.from({
        length: totalChoiceCount
    }, (_, i)=>{
        const choiceLabel = poll[`choice${i + 1}_label`].string_value;
        const choiceCount = parseInt(poll[`choice${i + 1}_count`].string_value);
        return {
            label: choiceLabel,
            count: choiceCount,
            percentage: choicePercentages[i]
        };
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: s.root,
        children: [
            choices.map((choice, i)=>/*#__PURE__*/ _jsx(TweetPollChoice, {
                    choice: choice
                }, i)),
            /*#__PURE__*/ _jsx(TweetPollInfo, {
                voteCount: totalVoteCount,
                endDateTime: poll.end_datetime_utc.string_value
            })
        ]
    });
};
const TweetPollInfo = ({ voteCount, endDateTime })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(infoStyles.info),
        children: /*#__PURE__*/ _jsxs("span", {
            children: [
                formatVoteCount(voteCount),
                " votes ·",
                ' ',
                formatRemainingTime(new Date(endDateTime))
            ]
        })
    });
};
const TweetPollChoice = ({ choice })=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: s.choice,
        title: `Votes: ${formatVoteCount(choice.count)}`,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: s.bar,
                        style: {
                            width: `${choice.percentage}%`
                        }
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: s.percent,
                        children: [
                            choice.percentage,
                            "%"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: s.label,
                children: choice.label
            })
        ]
    });
};
